import { useIonModal } from '@ionic/react'
import { AnimatePresence, motion } from 'framer-motion'

import { UserListCard, UserListCardSkeleton } from '@apps-common/apps/portal/pages/units/pages/manage/pages/users/components'
import { MyMonitoringUserModifyModal } from '@apps-common/apps/portal/pages/units/pages/manage/pages/users/modals/my-monitoring-modify-modal'
import { NoResultsAddCard } from '@apps-common/components/common'
import { motionFadeIn } from '@apps-common/config/motion-variants'
import { UNIT_STATUS_CANCELLED } from '@apps-common/config/unit-filter'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import { IMyMonitoringUserModel } from '@apps-common/types/portal/users'

interface IProps {
  status: string
  unitId: string
  ipAddress: string
  users: IMyMonitoringUserModel[]
  loading: boolean
}

export const MyMonitoringUsers: React.FC<IProps> = ({ status, unitId, ipAddress, users, loading }) => {
  const [present, dismiss] = useIonModal(MyMonitoringUserModifyModal, {
    componentProps: {
      unit: {
        unitId,
        ipAddress
      },
      existingIds: users.map((u) => u.id)
    },
    onDismiss: (data: string, role: string) => dismiss(data, role),
    enableBackdropDismiss: true
  })

  return (
    <div className='max-w-full sm:max-w-[1000px]'>
      <div className='grid grid-cols-1 lg:grid-cols-2 gap-[15px]'>
        <AnimatePresence mode='popLayout'>
          {loading &&
            Array.from(Array(4).keys()).map((u, i) => (
              <motion.div key={`unit-my-monitoring-user-${i}`} {...motionFadeIn(0.25)}>
                <UserListCardSkeleton />
              </motion.div>
            ))}
          {!loading && users && users.length === 0 && (
            <motion.div key='no-my-monitoring-user-create-button' {...motionFadeIn(0.25)}>
              <NoResultsAddCard
                message='Add a new myMonitoring user.'
                disabled={loading || status === UNIT_STATUS_CANCELLED.value}
                callback={() =>
                  present({
                    enterAnimation: modalSlideUpEnterAnimation,
                    leaveAnimation: modalSlideUpLeaveAnimation
                  })
                }
              />
            </motion.div>
          )}
          {!loading &&
            users &&
            users.length > 0 &&
            users.map((u, i) => (
              <motion.div key={`unit-my-monitoring-user-${u.id}`} {...motionFadeIn(0.25)}>
                <UserListCard
                  index={i}
                  type='myMonitoring'
                  unitId={unitId}
                  ipAddress={ipAddress}
                  userId={u.id}
                  profileImage={u.profileImage}
                  name={`${u.firstName} ${u.lastName}`}
                  email={u.email}
                  zone={u.userNumber}
                  partition={u.userPartition}
                />
              </motion.div>
            ))}
        </AnimatePresence>
      </div>
    </div>
  )
}
